/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { SubscriptionTypeDtoModel, SubscriptionTypeVoModel } from '@well/domain';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionTypeResourceService extends AbstractResourceService<SubscriptionTypeVoModel,
  SubscriptionTypeDtoModel,
  any,
  any> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('subscriptionTypeUrl'),
      SubscriptionTypeVoModel,
      SubscriptionTypeDtoModel
    );
  }

  getPublicSubscriptionTypes(companyType: string): Observable<JsonApiResource<SubscriptionTypeVoModel[], JsonApiListResourceMetadataBase>> {
      return <Observable<JsonApiResource<SubscriptionTypeVoModel[], JsonApiListResourceMetadataBase>>>this.httpClient?.get(`${this.url}/public/${companyType}`,{headers: this.headers});
  }

  getSubscriptionTypesForLegalEntity(legalEntityUuid: string): Observable<JsonApiResource<SubscriptionTypeVoModel[], JsonApiListResourceMetadataBase>>{
    return <Observable<JsonApiResource<SubscriptionTypeVoModel[], JsonApiListResourceMetadataBase>>>this.httpClient?.get(`${this.url}/legalEntity/${legalEntityUuid}`);
  }
}
